import NotListedLocationIcon from "@mui/icons-material/NotListedLocation";
import  {Marker,LineLayer,Source,Layer} from "react-map-gl";
import Tooltip from "@mui/material/Tooltip";
import { accent } from '../utils/colorDict';

const SuggestionsLayer =({bounds,handleModalData,suggestions})=>
{

  let coords=suggestions?.map(s=>([s.geometry.coordinates[1],s.geometry.coordinates[0]])) || []
  let lineData = {
    type: "Feature",
    properties: {},
    geometry: {
      type: "LineString",
    coordinates: coords 
    }
  } 

  return  <>
  
  {suggestions ? suggestions.map((item, i) =>


        <Marker
          key={i}
          onClick={() => {
            handleModalData(item,item.properties.mediatype);
          }}
          latitude={item.geometry.coordinates[0]}
          longitude={item.geometry.coordinates[1]}
          anchor="bottom"
        >
          <Tooltip title={item.properties.title} open={true}>
          <NotListedLocationIcon sx={{ color: accent }} />
          </Tooltip>
        </Marker>
      ) : null}
      </>}
    
        
export default SuggestionsLayer